module.exports = __webpack_public_path__ + "static/media/telestrate.9284dfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/telestrate.png
// module id = 7535
// module chunks = 0